import React from "react";
import PropTypes from "prop-types";
import useLanguageChange from "../../hooks/useLanguageChange";
import { setStrStartsIn } from "../../reducers/common-reducer";
import { useDispatch, useSelector } from "react-redux";
import CenterModal from "../UI/Modal/CenterModal";
import { GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";

const ScheduleSessionModal = ({ dispatchJoinMeeting }) => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    const { strStartsIn } = useSelector((state) => state.commonReducer);

    /* Schedule session modal data */
    const header = (
        <>
            <h5 className='modal-title'>{localisedValues?.upcoming_event}</h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={() => dispatch(setStrStartsIn(null))}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const body = (
        <div className='cms-modal-text'>
            <p>
                {localisedValues?.please_wait_for_the_host_to_start_this_event}
                <br></br>
                {!GLOBAL_MEETING_DATA.onlySecondsDiff ? (
                    <span>
                        {localisedValues?.scheduled_to_start_in}&nbsp;<strong>{strStartsIn}</strong>
                    </span>
                ) : (
                    <span>{localisedValues?.schedule_to_start_in_a_few_seconds}</span>
                )}
            </p>
        </div>
    );

    const footer = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-link' onClick={() => dispatch(setStrStartsIn(null))}>
                    {localisedValues?.okay_initcap}
                </button>
            </div>
            <div className='button'>
                <button className='btn default-btn-primary' onClick={() => handleRetryButton()}>
                    {localisedValues?.retry}
                </button>
            </div>
        </div>
    );

    const handleRetryButton = () => {
        dispatch(setStrStartsIn(null));
        dispatchJoinMeeting();
    };

    return (
        <CenterModal
            showModal={true}
            modalClass='default-modal mob-bottom-top privacy-policy-modal'
            className='modal-dialog-centered modal-dialog-scrollable'
            bodyClassName='default-custom-scroll'
            footerClassName='privacy-policy-modal-footer'
            header={header}
            body={body}
            footer={footer}
            backdrop={"static"}
        />
    );
};

ScheduleSessionModal.propTypes = {
    dispatchJoinMeeting: PropTypes.func,
};

export default ScheduleSessionModal;
